var map = {
	"./pages/cancelar-paciente/cancelar-paciente.module": [
		"./src/app/pages/cancelar-paciente/cancelar-paciente.module.ts",
		"pages-cancelar-paciente-cancelar-paciente-module"
	],
	"./pages/configuraciones/camas/camas.module": [
		"./src/app/pages/configuraciones/camas/camas.module.ts",
		"pages-configuraciones-camas-camas-module"
	],
	"./pages/configuraciones/correo/correo.module": [
		"./src/app/pages/configuraciones/correo/correo.module.ts",
		"pages-configuraciones-correo-correo-module"
	],
	"./pages/detalle-correo/detalle-correo.module": [
		"./src/app/pages/detalle-correo/detalle-correo.module.ts",
		"pages-detalle-correo-detalle-correo-module"
	],
	"./pages/detalle-evolucion/detalle-evolucion.module": [
		"./src/app/pages/detalle-evolucion/detalle-evolucion.module.ts",
		"default~pages-detalle-evolucion-detalle-evolucion-module~pages-detalle-ficha-detalle-ficha-module~pa~d541edf4",
		"pages-detalle-evolucion-detalle-evolucion-module"
	],
	"./pages/detalle-ficha/detalle-ficha.module": [
		"./src/app/pages/detalle-ficha/detalle-ficha.module.ts",
		"default~home-home-module~pages-detalle-ficha-detalle-ficha-module~pages-ingreso-evaluacion-clinica-i~51c9cea1",
		"default~pages-detalle-evolucion-detalle-evolucion-module~pages-detalle-ficha-detalle-ficha-module~pa~d541edf4",
		"default~pages-detalle-ficha-detalle-ficha-module~pages-ingreso-urgencia-ingreso-urgencia-module",
		"pages-detalle-ficha-detalle-ficha-module"
	],
	"./pages/ingreso-caso/ingreso-caso.module": [
		"./src/app/pages/ingreso-caso/ingreso-caso.module.ts",
		"pages-ingreso-caso-ingreso-caso-module"
	],
	"./pages/ingreso-evaluacion-clinica/ingreso-evaluacion-clinica.module": [
		"./src/app/pages/ingreso-evaluacion-clinica/ingreso-evaluacion-clinica.module.ts",
		"default~home-home-module~pages-detalle-ficha-detalle-ficha-module~pages-ingreso-evaluacion-clinica-i~51c9cea1",
		"default~pages-ingreso-evaluacion-clinica-ingreso-evaluacion-clinica-module~pages-ingreso-urgencia-in~7ea933d0",
		"pages-ingreso-evaluacion-clinica-ingreso-evaluacion-clinica-module"
	],
	"./pages/ingreso-urgencia/ingreso-urgencia.module": [
		"./src/app/pages/ingreso-urgencia/ingreso-urgencia.module.ts",
		"default~home-home-module~pages-detalle-ficha-detalle-ficha-module~pages-ingreso-evaluacion-clinica-i~51c9cea1",
		"default~pages-detalle-evolucion-detalle-evolucion-module~pages-detalle-ficha-detalle-ficha-module~pa~d541edf4",
		"default~home-home-module~pages-ingreso-urgencia-ingreso-urgencia-module",
		"default~pages-detalle-ficha-detalle-ficha-module~pages-ingreso-urgencia-ingreso-urgencia-module",
		"default~pages-ingreso-evaluacion-clinica-ingreso-evaluacion-clinica-module~pages-ingreso-urgencia-in~7ea933d0",
		"pages-ingreso-urgencia-ingreso-urgencia-module"
	],
	"./pages/notificaciones/notificaciones.module": [
		"./src/app/pages/notificaciones/notificaciones.module.ts",
		"pages-notificaciones-notificaciones-module"
	],
	"./pages/panel-control/panel-control.module": [
		"./src/app/pages/panel-control/panel-control.module.ts",
		"pages-panel-control-panel-control-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;